const BUTTON_CLASS = 'button';

class Button {
    constructor() {
        this._buttons = document.querySelectorAll(`.${BUTTON_CLASS}`);
        if (this._buttons) {
            this._run(true);
            addEventListener('resize', () => {
                this._run();
            });
            document.addEventListener('openmodal', () => {
                this._run();
            });
        }
    }

    _run = (firstLoad = false) => {
        this._buttons.forEach((button) => {
            const duration = parseFloat(getComputedStyle(button).transitionDuration) * 1000;

            if (!firstLoad) {
                button.style.transitionDuration = '0s';
            }
            this._resetButtonStyles(button);

            setTimeout(() => {
                const width = button.offsetWidth + 'px';

                if (width !== '0px') {
                    this._setButtonsStyles(button, width);

                    if (!firstLoad) {
                        setTimeout(() => {
                            button.style.transitionDuration = '';
                        }, duration);
                    }
                }
            }, 0);
        });
    };

    _resetButtonStyles = (button) => {
        button.style.width = '';
        button.style.paddingLeft = '';
        button.style.paddingRight = '';
    };

    _setButtonsStyles = (button, width) => {
        button.style.width = width;
        button.style.paddingLeft = 0;
        button.style.paddingRight = 0;
    };
}

const button = new Button();
